export default class ListenTaskInfo {
  UpdateTaskStatusFn?: Function;
  UpdateTaskPriorityFn?: Function;
  UpdateTaskDateEndFn?: Function;
  UpdateTaskDifficultyFn?: Function;
  UpdateTaskFileNameFn?: Function;
  UpdateTaskNameFn?: Function;
  UpdateTaskDescriptionFn?: Function;
  UpdateTagsInTaskFn?: Function;
  UpdateTaskObserverFn?: Function;
  UpdateTaskPerformersFn?: Function;
  UpdateTaskSprintFn?: Function;
  UpdateTaskTypeFn?: Function;
  AddTaskFilesBatchFn?: Function;
  RemoveTaskQueueRelationFn?: Function;
  AddTaskQueueRelationFn?: Function;
  ChangeOrderNumberQueueTaskFn?: Function;
  RemoveTaskSubtaskFn?: Function;
  AttachTaskForParentSubtaskFn?: Function;
  RemoveTaskEstimatePerformerFn?: Function;
  RemoveTaskFilesFn?: Function;
  AddTaskFileFn?: Function;
  ListenCompleteAddFileFn?: Function;
  RemoveTaskFilesEventFn?: Function;


  

  constructor(value: Partial<ListenTaskInfo> = null) {
    Object.assign(this, value);
  }
}
